export const handleCookies = {
    getCookieWithNativeJs: (name) => {
        /* let regexp = new RegExp("(?:^" + name + "|;\s*" + name + ")=(.*?)(?:;|$)", "g");
         let result = regexp.exec(document.cookie);
         return (result === null) ? null : result[1];*/
        let re = new RegExp('[; ]' + name + '=([^\\s;]*)');
        let sMatch = (' ' + document.cookie).match(re);
        if (name && sMatch) {
            return decodeURI(sMatch[1]);
        }
        return '';
    },
    setCookieWithNativeJs: (name, value, expires) => {

        let cookie = name + "=" + encodeURI(value) + ";";

        if (expires) {
            // If it's a date
            if (expires instanceof Date) {
                // If it isn't a valid date
                if (isNaN(expires.getTime()))
                    expires = new Date();
            }
            else {
                expires = new Date(new Date().getTime() + parseInt(expires) * 1000 * 60 * 60 * 24);
            }
            cookie += "expires=" + expires.toGMTString() + ";";
        }

        document.cookie = cookie;

    },
    deleteCookieWithNativeJs: (name) => {

        // If the cookie exists
        if (handleCookies.getCookieWithNativeJs(name)) {
            handleCookies.setCookieWithNativeJs(name, "", -1);
        }
    },
    setCookie: (obj) => {


        if (window.bluecollarApp && window.bluecollarApp.$cookie) {

            Object.entries(obj).map(item=>{
                window.bluecollarApp.$cookie.set(`iskolig_${item[0]}`, item[1], 1)
            })

        } else {
            Object.entries(obj).map(item=>{
                handleCookies.setCookieWithNativeJs(`iskolig_${item[0]}`, item[1], 1)
            })
        }
    },
    getCookie: (name) => {
        let value = '';
        let _name = `iskolig_${name}`;

        if (window.iskolig && window.iskolig.$cookie) {
            value = window.iskolig.$cookie.get(_name);
        }
        else {
            value = handleCookies.getCookieWithNativeJs(_name);
        }
        return value;
    },
    deleteCookie: (name) => {
        let _name = `iskolig_${name}`;
        if (window.iskolig && window.iskolig.$cookie) {
            window.iskolig.$cookie.delete(_name);
        } else {
            handleCookies.deleteCookieWithNativeJs(_name);
        }
    }
};
